import {lazy} from 'react';

export const ProfileCabinetAsync = lazy(() =>
    import('./ProfileCabinet')
);
